import SearchSessions from "./SearchSessions";

const UserDashboard = () => {
  return <SearchSessions />;
};

export default UserDashboard;
